export const PROFILE_FILLING_PATH = '/profile-filling';

/**
 * Проверяет, заполнены ли обязательные поля профиля из RunUserDataRequest
 * @param {Object} userData - данные профиля
 * @return {Boolean}
 */
export const isProfileComplete = (userData) => {
    if (!userData) {
        return false;
    }

    const firstName = String(userData.firstName || '').trim();
    const lastName = String(userData.lastName || userData.surname || '').trim();
    const email = String(userData.email || '').trim();
    const agencies = Array.isArray(userData.agencies) && userData.agencies.length > 0;

    return Boolean(firstName && lastName && email) && agencies;
};

/**
 * Редирект после авторизации: на дозаполнение профиля или на целевую страницу
 * @param {Object} router - экземпляр Vue Router
 * @param {Object} store - экземпляр Vuex store
 * @param {String} fallbackPath - страница по умолчанию, если нет query.redirect
 * @return {Promise<void>}
 */
export const redirectAfterAuth = async (router, store, fallbackPath = '/appointments') => {
    const query = {...router.currentRoute.query};
    const redirectPath = query.redirect;

    delete query.redirect;

    try {
        await store.dispatch('getUserData');
    } catch (error) {
        // Если профиль не удалось получить — решим по факту авторизации ниже
    }

    if (!store.getters.GET_IS_AUTHENTICATED) {
        await router.push({
            path : '/login',
            query: {
                ...query,
                ...(redirectPath ? {redirect: redirectPath} : {})
            }
        }).catch(() => {});

        return;
    }

    const targetPath = redirectPath || fallbackPath;

    if (!store.getters.GET_IS_PROFILE_COMPLETE) {
        await router.push({
            path : PROFILE_FILLING_PATH,
            query: {
                ...query,
                redirect: targetPath
            }
        }).catch(() => {});

        return;
    }

    await router.push({
        path: targetPath,
        query
    }).catch(() => {});
};
